<template>
  <div class="product">
    <div class="left">
      <img :src="productInfo.mainImage" alt="" />
    </div>
    <div class="right">
      <div class="desc title">{{ productInfo.productName }}</div>
      <div class="info">
        <div class="infoLeft">
          <div class="desc">{{ productInfo.metalName }}</div>
          <div class="desc">{{ productInfo.weight + "g" }}</div>
        </div>
        <div class="quantity">X{{ productInfo.quantity }}</div>
      </div>
      <div class="number">
        <div class="desc sn">编号：</div>
        <div class="desc">{{ productInfo.productSn }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["productInfo"],
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.product {
  width: 602px;
  height: 180px;
  display: flex;
  justify-content: space-between;
  .left {
    width: 180px;
    height: 180px;
    border-radius: 16px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }
  }
  .right {
    width: 398px;
    height: 168px;
    .title {
      width: 336px;
      height: 40px;
      line-height: 40px;
      word-break: keep-all; /* 不换行 */
      white-space: nowrap; /* 不换行 */
      overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
      text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用*/
    }
    .desc {
      font-size: 28px;
      color: rgba(0, 0, 0, 1);
    }
    .info {
      width: 398px;
      height: 46px;
      display: flex;
      justify-content: space-between;
      margin: 24px 0;
      .infoLeft {
        width: 218px;
        height: 40px;
        display: flex;
        line-height: 40px;
        justify-content: space-between;
      }
      .quantity {
        color: rgba(0, 0, 0, 1);
        font-size: 22px;
        font-weight: bold;
        line-height: 40px;
      }
    }
    .number {
      width: 373px;
      height: 40px;
      display: flex;
      line-height: 40px;
      justify-content: space-between;
      .sn {
        width: 100px;
      }
    }
  }
}
</style>
